import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, InputGroup, Spinner as BSSpinner } from 'react-bootstrap';
import { showToast } from './lib';
import { submitLogin } from './auth';

const Login = ({ onAuthenticated }) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!email || !password) {
      showToast('warning', 'Campos requeridos', 'Ingresa correo y contraseña.');
      return;
    }
    setLoading(true);
    try {
      const response = await submitLogin(email, password);
      const data = await response.json();
      if (response.ok) {
        showToast('success', 'Bienvenido', 'Iniciando sesión...');
        if (onAuthenticated) onAuthenticated();
        navigate('/dashboard');
      } else {
        showToast('danger', 'Error de autenticación', data.message || 'Credenciales incorrectas');
        setLoading(false);
      }
    } catch (err) {
      console.error('Login error:', err);
      showToast('danger', 'Error de conexión', 'No se pudo conectar con el servidor.');
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleLogin();
    }
  };

  return (
    <div className="bv-login-page">
      <div className="bv-login-brand-panel">
        <div className="bv-login-brand-inner">
          <img
            src="https://cdn.shopify.com/s/files/1/1437/8626/files/Homepage_0004_Falcon.png?v=1614320785"
            alt="Birdman"
            className="bv-login-brand-logo"
          />
          <h1 className="bv-login-brand-title">Birdman Vacaciones</h1>
          <p className="bv-login-brand-subtitle">
            Gestión de vacaciones y días económicos
          </p>
          <div className="bv-login-brand-decoration" aria-hidden="true">
            <span className="bv-dot" />
            <span className="bv-dot" />
            <span className="bv-dot" />
          </div>
        </div>
      </div>

      <div className="bv-login-form-panel">
        <div className="bv-login-form-card" onKeyDown={handleKeyPress}>
          <img
            src="https://cdn.shopify.com/s/files/1/1437/8626/files/Homepage_0004_Falcon.png?v=1614320785"
            alt="Birdman"
            className="bv-login-mobile-logo"
          />
          <h2 className="bv-login-title">Iniciar Sesión</h2>
          <p className="bv-login-subtitle">Ingresa con tu cuenta corporativa</p>

          <Form.Group className="mb-3">
            <Form.Label className="bv-login-label">Correo electrónico</Form.Label>
            <InputGroup className="bv-login-input-group">
              <InputGroup.Text>
                <i className="bi bi-envelope-fill" />
              </InputGroup.Text>
              <Form.Control
                type="email"
                placeholder="tu.correo@vidabirdman.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                disabled={loading}
              />
            </InputGroup>
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label className="bv-login-label">Contraseña</Form.Label>
            <InputGroup className="bv-login-input-group">
              <InputGroup.Text>
                <i className="bi bi-lock-fill" />
              </InputGroup.Text>
              <Form.Control
                type={showPassword ? 'text' : 'password'}
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                disabled={loading}
              />
              <InputGroup.Text
                role="button"
                onClick={() => setShowPassword((s) => !s)}
                className="bv-login-toggle-pass"
                aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
              >
                <i className={`bi ${showPassword ? 'bi-eye-slash-fill' : 'bi-eye-fill'}`} />
              </InputGroup.Text>
            </InputGroup>
          </Form.Group>

          <button
            type="button"
            className="bv-login-button"
            onClick={handleLogin}
            disabled={loading}
          >
            {loading ? (
              <>
                <BSSpinner as="span" size="sm" animation="border" className="me-2" />
                Entrando...
              </>
            ) : (
              <>
                Entrar
                <i className="bi bi-arrow-right ms-2" />
              </>
            )}
          </button>

          <p className="bv-login-footer">
            <i className="bi bi-shield-lock me-1" />
            Conexión segura
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
